import { Link } from "lucide-react";
import { FC } from "react";
import { useGetInventories } from "~/services/inventory";

type Props = {
  value?: string[];
  onChange?: (value: string[]) => void;
};

export const InventoriesSelect: FC<Props> = ({ value, onChange }) => {
  const { data: inventoryItems } = useGetInventories();

  const handleRelatedItemChange = (id: string) => {
    if (value?.includes(id)) {
      onChange?.(value.filter((itemId) => itemId !== id));
    } else {
      onChange?.([...(value || []), id]);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {inventoryItems?.items.map((item) => (
        <label
          key={item.id}
          className={`flex items-center space-x-2 p-2 border rounded-lg cursor-pointer ${
            value?.includes(item.id) ? "bg-blue-50 border-blue-300" : ""
          }`}
          onClick={() => handleRelatedItemChange(item.id)}
        >
          <Link
            size={16}
            className={
              value?.includes(item.id) ? "text-blue-500" : "text-gray-400"
            }
          />
          <span className="mr-1 font-medium">{item.inventoryRef}:</span>
          <span>{item.title}</span>
        </label>
      ))}
    </div>
  );
};
